var _defs, _rect, _text, _circle, _rect2, _text2, _path, _text3, _rect3, _path2, _text4, _polygon, _text5, _text6, _path3, _text7, _polygon2, _text8, _text9, _path4, _text0, _polygon3, _text1, _text10, _path5, _text11, _polygon4, _text12, _text13, _path6, _text14, _polygon5, _text15, _text16, _path7, _text17, _path8, _text18, _path9, _text19, _path0, _text20, _circle2, _line, _line2, _path1, _text21, _circle3, _line3, _line4, _path10, _text22, _circle4, _line5, _line6, _path11, _text23, _circle5, _line7, _line8, _path12, _text24, _polygon6, _rect4, _path13, _text25, _polygon7, _text26, _text27, _path14, _text28, _polygon8, _text29, _text30, _path15, _text31, _polygon9, _text32, _text33, _path16, _text34, _path17, _text35, _circle6, _line9, _line0, _path18, _text36, _polygon0, _text37, _text38, _path19, _text39, _path20, _text40, _path21, _text41, _path22, _text42, _circle7, _line1, _line10, _path23, _text43, _circle8, _line11, _line12, _path24, _text44, _polygon1, _rect5, _path25, _text45, _polygon10, _text46, _text47, _path26, _text48, _polygon11, _text49, _text50, _path27, _text51, _path28, _text52, _path29, _text53, _path30, _text54, _circle9, _line13, _line14, _path31, _text55, _polygon12, _rect6, _path32, _text56, _polygon13, _text57, _text58, _path33, _text59, _path34, _text60, _circle0, _line15, _line16, _polygon14, _text61, _text62, _polygon15, _circle1, _line17, _line18, _line19, _polygon16, _line20, _polygon17, _line21, _polygon18, _line22, _polygon19, _line23, _polygon20, _line24, _line25, _polygon21, _line26, _line27, _polygon22, _line28, _line29, _polygon23, _line30, _polygon24, _line31, _polygon25, _line32, _line33, _polygon26, _line34, _line35, _polygon27, _line36, _polygon28, _line37, _polygon29, _line38, _line39, _polygon30, _line40, _line41, _polygon31, _line42, _polygon32, _line43, _polygon33, _line44, _line45, _polygon34, _line46, _line47, _polygon35, _line48, _polygon36, _line49, _line50, _polygon37, _line51, _line52, _polygon38, _line53, _line54, _polygon39, _line55, _polygon40, _line56, _polygon41, _line57, _line58, _polygon42, _line59, _line60, _polygon43, _line61, _line62, _line63, _polygon44, _line64, _polygon45, _line65, _polygon46, _line66, _polygon47, _line67, _polygon48, _line68, _line69, _polygon49, _line70, _line71, _polygon50, _line72, _line73, _polygon51, _line74, _polygon52, _line75, _polygon53, _line76, _line77, _polygon54, _line78, _line79, _polygon55, _line80, _polygon56, _line81, _line82, _polygon57, _line83, _line84, _polygon58, _line85, _line86, _polygon59, _line87, _polygon60, _line88, _polygon61, _line89, _polygon62, _line90, _polygon63, _line91, _line92, _polygon64, _line93, _line94, _polygon65, _line95, _line96, _polygon66, _line97, _polygon67, _line98, _line99, _polygon68, _line100, _line101, _polygon69, _line102, _line103, _polygon70, _line104, _polygon71, _line105, _polygon72, _line106, _line107, _polygon73, _line108, _line109, _polygon74, _line110, _line111, _line112, _polygon75, _line113, _polygon76, _line114, _polygon77, _line115, _line116, _polygon78, _line117, _polygon79, _line118, _polygon80;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlowChartFinal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1989 3284.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        font-size: 21.88px;\n        text-decoration: underline;\n      }\n\n      .st0, .st1, .st2, .st3, .st4, .st5 {\n        fill: #fff;\n      }\n\n      .st0, .st4 {\n        font-family: Helvetica-Bold, Helvetica;\n        font-weight: 700;\n      }\n\n      .st1 {\n        font-size: 17.19px;\n      }\n\n      .st1, .st2 {\n        font-family: Helvetica, Helvetica;\n      }\n\n      .st1, .st2, .st4 {\n        isolation: isolate;\n      }\n\n      .st6 {\n        fill: #521014;\n      }\n\n      .st6, .st7, .st8, .st3, .st9, .st10, .st11, .st12, .st13, .st5 {\n        stroke-miterlimit: 4;\n      }\n\n      .st6, .st7, .st8, .st9, .st10, .st11, .st12, .st13, .st5 {\n        stroke: #fff;\n      }\n\n      .st6, .st10, .st11, .st12 {\n        stroke-width: .78px;\n      }\n\n      .st2 {\n        font-size: 18.75px;\n      }\n\n      .st14 {\n        fill: #231f20;\n      }\n\n      .st7, .st8 {\n        stroke-width: 2.34px;\n      }\n\n      .st7, .st9, .st13 {\n        fill: none;\n      }\n\n      .st15 {\n        letter-spacing: .88em;\n      }\n\n      .st8 {\n        fill: #333132;\n      }\n\n      .st16 {\n        letter-spacing: .37em;\n      }\n\n      .st17 {\n        letter-spacing: .37em;\n      }\n\n      .st18 {\n        letter-spacing: .37em;\n      }\n\n      .st19 {\n        letter-spacing: .39em;\n      }\n\n      .st20 {\n        letter-spacing: .39em;\n      }\n\n      .st21 {\n        letter-spacing: .37em;\n      }\n\n      .st22 {\n        letter-spacing: .37em;\n      }\n\n      .st23 {\n        letter-spacing: .39em;\n      }\n\n      .st24 {\n        letter-spacing: .4em;\n      }\n\n      .st25 {\n        letter-spacing: .4em;\n      }\n\n      .st26 {\n        letter-spacing: .4em;\n      }\n\n      .st27 {\n        letter-spacing: .4em;\n      }\n\n      .st28 {\n        letter-spacing: .42em;\n      }\n\n      .st29 {\n        letter-spacing: .42em;\n      }\n\n      .st30 {\n        letter-spacing: .42em;\n      }\n\n      .st31 {\n        letter-spacing: .42em;\n      }\n\n      .st32 {\n        letter-spacing: .44em;\n      }\n\n      .st33 {\n        letter-spacing: .3em;\n      }\n\n      .st34 {\n        letter-spacing: .33em;\n      }\n\n      .st35 {\n        letter-spacing: .33em;\n      }\n\n      .st36 {\n        letter-spacing: .33em;\n      }\n\n      .st37 {\n        letter-spacing: .33em;\n      }\n\n      .st38 {\n        letter-spacing: .3em;\n      }\n\n      .st39 {\n        letter-spacing: .32em;\n      }\n\n      .st40 {\n        letter-spacing: .32em;\n      }\n\n      .st41 {\n        letter-spacing: .34em;\n      }\n\n      .st42 {\n        letter-spacing: .34em;\n      }\n\n      .st43 {\n        letter-spacing: .34em;\n      }\n\n      .st44 {\n        letter-spacing: .34em;\n      }\n\n      .st45 {\n        letter-spacing: .33em;\n      }\n\n      .st46 {\n        letter-spacing: .33em;\n      }\n\n      .st47 {\n        letter-spacing: .34em;\n      }\n\n      .st48 {\n        letter-spacing: .35em;\n      }\n\n      .st49 {\n        letter-spacing: .35em;\n      }\n\n      .st50 {\n        letter-spacing: .33em;\n      }\n\n      .st51 {\n        letter-spacing: .33em;\n      }\n\n      .st52 {\n        letter-spacing: .35em;\n      }\n\n      .st53 {\n        letter-spacing: .35em;\n      }\n\n      .st54 {\n        letter-spacing: .35em;\n      }\n\n      .st55 {\n        letter-spacing: .38em;\n      }\n\n      .st56 {\n        letter-spacing: .38em;\n      }\n\n      .st57 {\n        letter-spacing: .25em;\n      }\n\n      .st58 {\n        letter-spacing: .26em;\n      }\n\n      .st59 {\n        letter-spacing: .26em;\n      }\n\n      .st60 {\n        letter-spacing: .26em;\n      }\n\n      .st61 {\n        letter-spacing: .27em;\n      }\n\n      .st62 {\n        letter-spacing: .27em;\n      }\n\n      .st63 {\n        letter-spacing: .27em;\n      }\n\n      .st64 {\n        letter-spacing: .27em;\n      }\n\n      .st65 {\n        letter-spacing: .29em;\n      }\n\n      .st66 {\n        letter-spacing: .29em;\n      }\n\n      .st67 {\n        letter-spacing: .29em;\n      }\n\n      .st68 {\n        letter-spacing: .29em;\n      }\n\n      .st69 {\n        letter-spacing: .29em;\n      }\n\n      .st70 {\n        letter-spacing: .31em;\n      }\n\n      .st71 {\n        letter-spacing: .31em;\n      }\n\n      .st72 {\n        letter-spacing: .29em;\n      }\n\n      .st73 {\n        letter-spacing: .29em;\n      }\n\n      .st74 {\n        letter-spacing: .29em;\n      }\n\n      .st75 {\n        letter-spacing: .22em;\n      }\n\n      .st76 {\n        letter-spacing: .22em;\n      }\n\n      .st77 {\n        letter-spacing: .25em;\n      }\n\n      .st78 {\n        letter-spacing: .25em;\n      }\n\n      .st79 {\n        letter-spacing: .57em;\n      }\n\n      .st80 {\n        letter-spacing: .57em;\n      }\n\n      .st81 {\n        letter-spacing: .57em;\n      }\n\n      .st82 {\n        letter-spacing: .46em;\n      }\n\n      .st83 {\n        letter-spacing: .46em;\n      }\n\n      .st3 {\n        stroke: #222;\n      }\n\n      .st3, .st9, .st5 {\n        stroke-width: 1.56px;\n      }\n\n      .st84 {\n        letter-spacing: .17em;\n      }\n\n      .st10 {\n        fill: #44485a;\n      }\n\n      .st4 {\n        font-size: 28.13px;\n      }\n\n      .st11 {\n        fill: #14381b;\n      }\n\n      .st12 {\n        fill: #121244;\n      }\n\n      .st13 {\n        stroke-width: 3.91px;\n      }\n\n      .st85 {\n        letter-spacing: .02em;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st14",
    x: -0.31,
    y: -0.61,
    width: 1989.13,
    height: 3284.75
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st4",
    transform: "translate(583.96 57.83)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Test"), /*#__PURE__*/React.createElement("tspan", {
    className: "st41",
    x: 57.84,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 75.25,
    y: 0
  }, "Flow"), /*#__PURE__*/React.createElement("tspan", {
    className: "st41",
    x: 139.31,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 156.72,
    y: 0
  }, "-"), /*#__PURE__*/React.createElement("tspan", {
    className: "st41",
    x: 166.08,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 183.5,
    y: 0
  }, "Data"), /*#__PURE__*/React.createElement("tspan", {
    className: "st41",
    x: 244.46,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 261.88,
    y: 0
  }, "Management"), /*#__PURE__*/React.createElement("tspan", {
    className: "st41",
    x: 433.81,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 451.22,
    y: 0
  }, "System"), /*#__PURE__*/React.createElement("tspan", {
    className: "st41",
    x: 551.29,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 568.7,
    y: 0
  }, "(Shipping"), /*#__PURE__*/React.createElement("tspan", {
    className: "st41",
    x: 698.37,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 715.78,
    y: 0
  }, "Orders)"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 1552.7,
    cy: 96.58,
    r: 15.63
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 1487.49,
    y: 143.46,
    width: 130.42,
    height: 53.34,
    rx: 19.53,
    ry: 19.53
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(1503.11 177.22)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Launch"), /*#__PURE__*/React.createElement("tspan", {
    className: "st84",
    x: 61.52,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 70,
    y: 0
  }, "CLI"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1438.7,228.06h227.99c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53h-228c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(1434.8 261.81)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Choose"), /*#__PURE__*/React.createElement("tspan", {
    className: "st55",
    x: 64.63,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 76.88,
    y: 0
  }, "action"), /*#__PURE__*/React.createElement("tspan", {
    className: "st55",
    x: 126.92,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 139.17,
    y: 0
  }, "from"), /*#__PURE__*/React.createElement("tspan", {
    className: "st56",
    x: 176.67,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 188.92,
    y: 0
  }, "menu"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    x: 16.88,
    y: 297.02,
    width: 1946.78,
    height: 955.45
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M206.38,297.02v14.83l-15.63,15.63H16.88"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "st0",
    transform: "translate(21.57 319.73)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Add"), /*#__PURE__*/React.createElement("tspan", {
    className: "st51",
    x: 42.53,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 55.93,
    y: 0
  }, "Order"), /*#__PURE__*/React.createElement("tspan", {
    className: "st50",
    x: 115.5,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 128.9,
    y: 0
  }, "Test"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1462.06 354.04 1643.34 354.04 1662.09 372.79 1643.34 391.54 1462.06 391.54 1443.31 372.79 1462.06 354.04"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(1462.06 379.29)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "&quot;Add"), /*#__PURE__*/React.createElement("tspan", {
    className: "st57",
    x: 36.69,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 45.74,
    y: 0
  }, "Order"), /*#__PURE__*/React.createElement("tspan", {
    className: "st57",
    x: 89.68,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 98.74,
    y: 0
  }, "Selected?&quot;"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(1415.99 369.17)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st85",
    x: 0,
    y: 0
  }, "ye"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.73,
    y: 0
  }, "s"))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1087.16,407.17h297.89c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53h-297.89c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(1083.25 440.93)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xABinfo\xBB"), /*#__PURE__*/React.createElement("tspan", {
    className: "st17",
    x: 51.09,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 63.16,
    y: 0
  }, "Prompt"), /*#__PURE__*/React.createElement("tspan", {
    className: "st17",
    x: 123.6,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 135.68,
    y: 0
  }, "for"), /*#__PURE__*/React.createElement("tspan", {
    className: "st21",
    x: 157.56,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 169.64,
    y: 0
  }, "customer"), /*#__PURE__*/React.createElement("tspan", {
    className: "st17",
    x: 246.75,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 258.82,
    y: 0
  }, "name"))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1137.68 491.76 1334.53 491.76 1353.29 510.52 1334.53 529.27 1137.68 529.27 1118.93 510.52 1137.68 491.76"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(1137.68 517.01)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "&quot;Customer"), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 80.61,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 91.73,
    y: 0
  }, "name"), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 134.73,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 145.86,
    y: 0
  }, "valid?&quot;"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(1091.61 506.89)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st85",
    x: 0,
    y: 0
  }, "ye"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.73,
    y: 0
  }, "s"))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M755.36,544.89h281.27c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53h-281.27c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(751.45 578.65)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xABinfo\xBB"), /*#__PURE__*/React.createElement("tspan", {
    className: "st54",
    x: 51.09,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 62.91,
    y: 0
  }, "Prompt"), /*#__PURE__*/React.createElement("tspan", {
    className: "st53",
    x: 123.35,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 135.17,
    y: 0
  }, "for"), /*#__PURE__*/React.createElement("tspan", {
    className: "st54",
    x: 157.06,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 168.88,
    y: 0
  }, "shipper"), /*#__PURE__*/React.createElement("tspan", {
    className: "st53",
    x: 230.38,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 242.2,
    y: 0
  }, "name"))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "806.48 629.49 985.51 629.49 1004.26 648.24 985.51 666.99 806.48 666.99 787.73 648.24 806.48 629.49"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(806.48 654.74)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "&quot;Shipper"), /*#__PURE__*/React.createElement("tspan", {
    className: "st65",
    x: 65.35,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 75.19,
    y: 0
  }, "name"), /*#__PURE__*/React.createElement("tspan", {
    className: "st65",
    x: 118.19,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 128.03,
    y: 0
  }, "valid?&quot;"))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(760.41 644.61)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st85",
    x: 0,
    y: 0
  }, "ye"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.73,
    y: 0
  }, "s"))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M492.68,682.62h217.71c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53h-217.71c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(488.78 716.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xABinfo\xBB"), /*#__PURE__*/React.createElement("tspan", {
    className: "st27",
    x: 51.09,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 63.73,
    y: 0
  }, "Prompt"), /*#__PURE__*/React.createElement("tspan", {
    className: "st27",
    x: 124.17,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 136.82,
    y: 0
  }, "for"), /*#__PURE__*/React.createElement("tspan", {
    className: "st26",
    x: 158.7,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 171.34,
    y: 0
  }, "weight"))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "540.67 767.21 662.41 767.21 681.16 785.96 662.41 804.71 540.67 804.71 521.92 785.96 540.67 767.21"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(540.67 792.46)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "&quot;Weight"), /*#__PURE__*/React.createElement("tspan", {
    className: "st18",
    x: 59.6,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 70.73,
    y: 0
  }, "valid?&quot;"))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(494.6 782.34)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st85",
    x: 0,
    y: 0
  }, "ye"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.73,
    y: 0
  }, "s"))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M241.85,820.34h232.89c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53h-232.89c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(237.94 854.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xABinfo\xBB"), /*#__PURE__*/React.createElement("tspan", {
    className: "st19",
    x: 51.09,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 63.58,
    y: 0
  }, "Prompt"), /*#__PURE__*/React.createElement("tspan", {
    className: "st20",
    x: 124.02,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 136.51,
    y: 0
  }, "for"), /*#__PURE__*/React.createElement("tspan", {
    className: "st20",
    x: 158.4,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 170.89,
    y: 0
  }, "distance"))), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "290.17 904.93 426.42 904.93 445.17 923.69 426.42 942.44 290.17 942.44 271.42 923.69 290.17 904.93"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(290.17 930.18)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "&quot;Distance"), /*#__PURE__*/React.createElement("tspan", {
    className: "st32",
    x: 72.98,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 85.24,
    y: 0
  }, "valid?&quot;"))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(244.11 920.06)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st85",
    x: 0,
    y: 0
  }, "ye"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.73,
    y: 0
  }, "s"))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M86,958.06h214.58c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53H86c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(82.09 991.82)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xABsuccess\xBB"), /*#__PURE__*/React.createElement("tspan", {
    className: "st73",
    x: 88.6,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 99.22,
    y: 0
  }, "Calculate"), /*#__PURE__*/React.createElement("tspan", {
    className: "st72",
    x: 177.4,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 188.03,
    y: 0
  }, "cost"))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M98.53,1042.66h189.52c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53H98.53c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(94.62 1076.41)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xABsuccess\xBB"), /*#__PURE__*/React.createElement("tspan", {
    className: "st60",
    x: 88.6,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 98.68,
    y: 0
  }, "Store"), /*#__PURE__*/React.createElement("tspan", {
    className: "st59",
    x: 143.5,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 153.58,
    y: 0
  }, "order"))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M55.17,1127.25h276.26c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53H55.16c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(51.26 1161.01)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xABsuccess\xBB"), /*#__PURE__*/React.createElement("tspan", {
    className: "st80",
    x: 88.6,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 104.53,
    y: 0
  }, "Display"), /*#__PURE__*/React.createElement("tspan", {
    className: "st79",
    x: 166.02,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 181.95,
    y: 0
  }, "confirmation"))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M401.74,958.06h243.13c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53h-243.13c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(397.83 991.82)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xABerror\xBB"), /*#__PURE__*/React.createElement("tspan", {
    className: "st35",
    x: 60.45,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 71.84,
    y: 0
  }, "Show"), /*#__PURE__*/React.createElement("tspan", {
    className: "st36",
    x: 118.75,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 130.14,
    y: 0
  }, "distance"), /*#__PURE__*/React.createElement("tspan", {
    className: "st35",
    x: 199.98,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 211.37,
    y: 0
  }, "error"))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 523.3,
    cy: 1058.28,
    r: 15.63
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 513.63,
    y1: 1048.62,
    x2: 532.97,
    y2: 1067.95
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 532.97,
    y1: 1048.62,
    x2: 513.63,
    y2: 1067.95
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M730.81,820.34h227.95c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53h-227.95c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(726.9 854.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xABerror\xBB"), /*#__PURE__*/React.createElement("tspan", {
    className: "st42",
    x: 60.45,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 71.99,
    y: 0
  }, "Show"), /*#__PURE__*/React.createElement("tspan", {
    className: "st42",
    x: 118.9,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 130.44,
    y: 0
  }, "weight"), /*#__PURE__*/React.createElement("tspan", {
    className: "st42",
    x: 184.65,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 196.19,
    y: 0
  }, "error"))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 844.78,
    cy: 920.56,
    r: 15.63
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 835.12,
    y1: 910.89,
    x2: 854.45,
    y2: 930.23
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 854.45,
    y1: 910.89,
    x2: 835.12,
    y2: 930.23
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1044.7,682.62h291.51c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53h-291.51c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(1040.79 716.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xABerror\xBB"), /*#__PURE__*/React.createElement("tspan", {
    className: "st71",
    x: 60.45,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 71.45,
    y: 0
  }, "Show"), /*#__PURE__*/React.createElement("tspan", {
    className: "st70",
    x: 118.35,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 129.35,
    y: 0
  }, "shipper"), /*#__PURE__*/React.createElement("tspan", {
    className: "st71",
    x: 190.85,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 201.85,
    y: 0
  }, "name"), /*#__PURE__*/React.createElement("tspan", {
    className: "st70",
    x: 248.75,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 259.75,
    y: 0
  }, "error"))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 1190.46,
    cy: 782.84,
    r: 15.63
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 1180.79,
    y1: 773.17,
    x2: 1200.12,
    y2: 792.51
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 1200.12,
    y1: 773.17,
    x2: 1180.79,
    y2: 792.51
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1422.15,544.89h308.13c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53h-308.13c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(1418.24 578.65)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xABerror\xBB"), /*#__PURE__*/React.createElement("tspan", {
    className: "st40",
    x: 60.45,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 71.7,
    y: 0
  }, "Show"), /*#__PURE__*/React.createElement("tspan", {
    className: "st40",
    x: 118.6,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 129.85,
    y: 0
  }, "customer"), /*#__PURE__*/React.createElement("tspan", {
    className: "st39",
    x: 206.97,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 218.22,
    y: 0
  }, "name"), /*#__PURE__*/React.createElement("tspan", {
    className: "st40",
    x: 265.12,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 276.37,
    y: 0
  }, "error"))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 1576.21,
    cy: 645.11,
    r: 15.63
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 1566.55,
    y1: 635.45,
    x2: 1585.88,
    y2: 654.78
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 1585.88,
    y1: 635.45,
    x2: 1566.55,
    y2: 654.78
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1816.22,407.17h106.16c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53h-106.15c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(1812.31 440.93)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "-&gt;"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 17.2,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 38.92,
    y: 0
  }, "Continue"))), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1552.7 1196.21 1571.45 1214.97 1552.7 1233.72 1533.95 1214.97 1552.7 1196.21"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    x: 618.98,
    y: 1268.1,
    width: 1313.33,
    height: 964.83
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M843.03,1268.1v14.83l-15.63,15.63h-208.42"
  })), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    className: "st0",
    transform: "translate(623.67 1290.81)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Update"), /*#__PURE__*/React.createElement("tspan", {
    className: "st25",
    x: 74.15,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 89.01,
    y: 0
  }, "Order"), /*#__PURE__*/React.createElement("tspan", {
    className: "st24",
    x: 148.59,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 163.45,
    y: 0
  }, "Test"))), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1449.29 1325.12 1656.11 1325.12 1674.87 1343.87 1656.11 1362.62 1449.29 1362.62 1430.54 1343.87 1449.29 1325.12"
  })), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(1449.29 1350.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "&quot;Update"), /*#__PURE__*/React.createElement("tspan", {
    className: "st61",
    x: 61.53,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 70.94,
    y: 0
  }, "Order"), /*#__PURE__*/React.createElement("tspan", {
    className: "st64",
    x: 114.88,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 124.29,
    y: 0
  }, "Selected?&quot;"))), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(1403.22 1340.24)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st85",
    x: 0,
    y: 0
  }, "ye"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.73,
    y: 0
  }, "s"))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1159.66,1378.25h234.6c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53h-234.6c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(1155.75 1412.01)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xABinfo\xBB"), /*#__PURE__*/React.createElement("tspan", {
    className: "st69",
    x: 51.09,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 61.67,
    y: 0
  }, "Prompt"), /*#__PURE__*/React.createElement("tspan", {
    className: "st68",
    x: 122.11,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 132.7,
    y: 0
  }, "for"), /*#__PURE__*/React.createElement("tspan", {
    className: "st69",
    x: 154.58,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 165.16,
    y: 0
  }, "Order"), /*#__PURE__*/React.createElement("tspan", {
    className: "st68",
    x: 213.1,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 223.68,
    y: 0
  }, "ID"))), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1215.76 1462.84 1338.14 1462.84 1356.89 1481.59 1338.14 1500.34 1215.76 1500.34 1197.01 1481.59 1215.76 1462.84"
  })), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(1215.76 1488.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "&quot;Order"), /*#__PURE__*/React.createElement("tspan", {
    className: "st82",
    x: 50.04,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 62.79,
    y: 0
  }, "exists?&quot;"))), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(1169.69 1477.97)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st85",
    x: 0,
    y: 0
  }, "ye"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.73,
    y: 0
  }, "s"))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M873.4,1515.97h260.18c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53h-260.18c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(869.49 1549.73)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xABinfo\xBB"), /*#__PURE__*/React.createElement("tspan", {
    className: "st43",
    x: 51.09,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 62.59,
    y: 0
  }, "Prompt"), /*#__PURE__*/React.createElement("tspan", {
    className: "st43",
    x: 123.03,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 134.53,
    y: 0
  }, "for"), /*#__PURE__*/React.createElement("tspan", {
    className: "st43",
    x: 156.41,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 167.91,
    y: 0
  }, "new"), /*#__PURE__*/React.createElement("tspan", {
    className: "st44",
    x: 202.31,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 213.81,
    y: 0
  }, "weight"))), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "918.13 1600.56 1088.85 1600.56 1107.6 1619.32 1088.85 1638.07 918.13 1638.07 899.38 1619.32 918.13 1600.56"
  })), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(918.13 1625.81)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "&quot;Weight"), /*#__PURE__*/React.createElement("tspan", {
    className: "st23",
    x: 59.6,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 71.02,
    y: 0
  }, "input"), /*#__PURE__*/React.createElement("tspan", {
    className: "st23",
    x: 108.3,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 119.72,
    y: 0
  }, "valid?&quot;"))), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(872.06 1615.69)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st85",
    x: 0,
    y: 0
  }, "ye"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.73,
    y: 0
  }, "s"))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M733.94,1653.69h218.73c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53h-218.73c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(730.03 1687.45)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xABsuccess\xBB"), /*#__PURE__*/React.createElement("tspan", {
    className: "st47",
    x: 88.59,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 100.24,
    y: 0
  }, "Update"), /*#__PURE__*/React.createElement("tspan", {
    className: "st47",
    x: 160.71,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 172.35,
    y: 0
  }, "weight"))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1022.98,1653.69h281.39c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53h-281.39c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(1019.07 1687.45)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xABerror\xBB"), /*#__PURE__*/React.createElement("tspan", {
    className: "st48",
    x: 60.45,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 72.3,
    y: 0
  }, "Show"), /*#__PURE__*/React.createElement("tspan", {
    className: "st49",
    x: 119.21,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 131.06,
    y: 0
  }, "weight"), /*#__PURE__*/React.createElement("tspan", {
    className: "st48",
    x: 185.27,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 197.12,
    y: 0
  }, "input"), /*#__PURE__*/React.createElement("tspan", {
    className: "st48",
    x: 237.78,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 249.64,
    y: 0
  }, "error"))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 1163.68,
    cy: 1753.91,
    r: 15.63
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 1154.01,
    y1: 1744.24,
    x2: 1173.35,
    y2: 1763.58
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 1173.35,
    y1: 1744.24,
    x2: 1154.01,
    y2: 1763.58
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M865.81,1800.79h275.36c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53h-275.36c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(861.9 1834.55)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xABinfo\xBB"), /*#__PURE__*/React.createElement("tspan", {
    className: "st34",
    x: 51.09,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 62.48,
    y: 0
  }, "Prompt"), /*#__PURE__*/React.createElement("tspan", {
    className: "st34",
    x: 122.92,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 134.3,
    y: 0
  }, "for"), /*#__PURE__*/React.createElement("tspan", {
    className: "st37",
    x: 156.18,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 167.57,
    y: 0
  }, "new"), /*#__PURE__*/React.createElement("tspan", {
    className: "st34",
    x: 201.97,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 213.35,
    y: 0
  }, "distance"))), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "910.87 1885.39 1096.11 1885.39 1114.86 1904.14 1096.11 1922.89 910.87 1922.89 892.12 1904.14 910.87 1885.39"
  })), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(910.87 1910.63)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "&quot;Distance"), /*#__PURE__*/React.createElement("tspan", {
    className: "st28",
    x: 72.98,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 84.97,
    y: 0
  }, "input"), /*#__PURE__*/React.createElement("tspan", {
    className: "st29",
    x: 122.25,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 134.24,
    y: 0
  }, "valid?&quot;"))), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(864.8 1900.51)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st85",
    x: 0,
    y: 0
  }, "ye"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.73,
    y: 0
  }, "s"))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M712.84,1938.52h233.91c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53h-233.91c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(708.94 1972.27)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xABsuccess\xBB"), /*#__PURE__*/React.createElement("tspan", {
    className: "st45",
    x: 88.59,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 100.01,
    y: 0
  }, "Update"), /*#__PURE__*/React.createElement("tspan", {
    className: "st46",
    x: 160.48,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 171.9,
    y: 0
  }, "distance"))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M722.51,2023.11h214.58c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53h-214.58c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(718.6 2056.87)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xABsuccess\xBB"), /*#__PURE__*/React.createElement("tspan", {
    className: "st74",
    x: 88.59,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 99.22,
    y: 0
  }, "Calculate"), /*#__PURE__*/React.createElement("tspan", {
    className: "st72",
    x: 177.4,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 188.02,
    y: 0
  }, "cost"))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M701.02,2107.7h257.56c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53h-257.56c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(697.11 2141.46)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xABsuccess\xBB"), /*#__PURE__*/React.createElement("tspan", {
    className: "st83",
    x: 88.59,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 102.47,
    y: 0
  }, "Show"), /*#__PURE__*/React.createElement("tspan", {
    className: "st83",
    x: 149.38,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 163.25,
    y: 0
  }, "confirmation"))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1028.9,1938.52h296.57c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53h-296.57c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(1024.99 1972.27)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xABerror\xBB"), /*#__PURE__*/React.createElement("tspan", {
    className: "st52",
    x: 60.45,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 72.19,
    y: 0
  }, "Show"), /*#__PURE__*/React.createElement("tspan", {
    className: "st52",
    x: 119.09,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 130.83,
    y: 0
  }, "distance"), /*#__PURE__*/React.createElement("tspan", {
    className: "st52",
    x: 200.68,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 212.42,
    y: 0
  }, "input"), /*#__PURE__*/React.createElement("tspan", {
    className: "st52",
    x: 253.08,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 264.82,
    y: 0
  }, "error"))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 1177.18,
    cy: 2038.74,
    r: 15.63
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 1167.51,
    y1: 2029.07,
    x2: 1186.85,
    y2: 2048.4
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 1186.85,
    y1: 2029.07,
    x2: 1167.51,
    y2: 2048.4
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1411.41,1515.97h278.02c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53h-278.02c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(1407.5 1549.73)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xABerror\xBB"), /*#__PURE__*/React.createElement("tspan", {
    className: "st62",
    x: 60.45,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 70.71,
    y: 0
  }, "Show"), /*#__PURE__*/React.createElement("tspan", {
    className: "st63",
    x: 117.62,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 127.89,
    y: 0
  }, "&apos;Order"), /*#__PURE__*/React.createElement("tspan", {
    className: "st62",
    x: 179.4,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 189.66,
    y: 0
  }, "Not"), /*#__PURE__*/React.createElement("tspan", {
    className: "st62",
    x: 218.84,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 229.11,
    y: 0
  }, "Found&apos;"))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 1550.42,
    cy: 1616.19,
    r: 15.63
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 1540.75,
    y1: 1606.52,
    x2: 1560.09,
    y2: 1625.86
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 1560.09,
    y1: 1606.52,
    x2: 1540.75,
    y2: 1625.86
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1775.37,1378.25h106.15c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53h-106.15c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(1771.46 1412.01)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "-&gt;"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 17.2,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 38.92,
    y: 0
  }, "Continue"))), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1552.7 2176.67 1571.45 2195.42 1552.7 2214.17 1533.95 2195.42 1552.7 2176.67"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    x: 964.92,
    y: 2248.55,
    width: 915.19,
    height: 542.28
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1181.1,2248.55v14.83l-15.63,15.63h-200.56"
  })), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    className: "st0",
    transform: "translate(969.6 2271.26)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Delete"), /*#__PURE__*/React.createElement("tspan", {
    className: "st30",
    x: 65.66,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 80.84,
    y: 0
  }, "Order"), /*#__PURE__*/React.createElement("tspan", {
    className: "st31",
    x: 140.41,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 155.59,
    y: 0
  }, "Test"))), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1452.31 2305.57 1653.09 2305.57 1671.84 2324.32 1653.09 2343.07 1452.31 2343.07 1433.56 2324.32 1452.31 2305.57"
  })), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(1452.31 2330.82)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "&quot;Delete"), /*#__PURE__*/React.createElement("tspan", {
    className: "st58",
    x: 55.79,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 65.05,
    y: 0
  }, "Order"), /*#__PURE__*/React.createElement("tspan", {
    className: "st58",
    x: 108.99,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 118.25,
    y: 0
  }, "Selected?&quot;"))), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(1406.24 2320.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st85",
    x: 0,
    y: 0
  }, "ye"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.73,
    y: 0
  }, "s"))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1211.86,2358.7h234.6c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53h-234.6c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(1207.95 2392.46)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xABinfo\xBB"), /*#__PURE__*/React.createElement("tspan", {
    className: "st69",
    x: 51.09,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 61.67,
    y: 0
  }, "Prompt"), /*#__PURE__*/React.createElement("tspan", {
    className: "st68",
    x: 122.11,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 132.7,
    y: 0
  }, "for"), /*#__PURE__*/React.createElement("tspan", {
    className: "st69",
    x: 154.58,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 165.16,
    y: 0
  }, "Order"), /*#__PURE__*/React.createElement("tspan", {
    className: "st68",
    x: 213.1,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 223.68,
    y: 0
  }, "ID"))), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1267.97 2443.29 1390.35 2443.29 1409.1 2462.04 1390.35 2480.8 1267.97 2480.8 1249.22 2462.04 1267.97 2443.29"
  })), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(1267.97 2468.54)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "&quot;Order"), /*#__PURE__*/React.createElement("tspan", {
    className: "st82",
    x: 50.04,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 62.79,
    y: 0
  }, "exists?&quot;"))), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(1221.9 2458.42)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st85",
    x: 0,
    y: 0
  }, "ye"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.73,
    y: 0
  }, "s"))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1056.86,2496.42h206.49c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53h-206.49c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text51 || (_text51 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(1052.95 2530.18)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xABinfo\xBB"), /*#__PURE__*/React.createElement("tspan", {
    className: "st81",
    x: 51.09,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 67.04,
    y: 0
  }, "Confirm"), /*#__PURE__*/React.createElement("tspan", {
    className: "st81",
    x: 132.68,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 148.63,
    y: 0
  }, "deletion"))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1059.81,2581.02h200.59c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53h-200.59c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text52 || (_text52 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(1055.9 2614.77)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xABsuccess\xBB"), /*#__PURE__*/React.createElement("tspan", {
    className: "st38",
    x: 88.59,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 99.52,
    y: 0
  }, "Delete"), /*#__PURE__*/React.createElement("tspan", {
    className: "st33",
    x: 153.72,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 164.65,
    y: 0
  }, "order"))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1031.33,2665.61h257.56c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53h-257.56c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text53 || (_text53 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(1027.42 2699.36)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xABsuccess\xBB"), /*#__PURE__*/React.createElement("tspan", {
    className: "st83",
    x: 88.59,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 102.47,
    y: 0
  }, "Show"), /*#__PURE__*/React.createElement("tspan", {
    className: "st83",
    x: 149.38,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 163.25,
    y: 0
  }, "confirmation"))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1359.2,2496.42h278.02c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53h-278.02c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text54 || (_text54 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(1355.29 2530.18)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xABerror\xBB"), /*#__PURE__*/React.createElement("tspan", {
    className: "st63",
    x: 60.45,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 70.71,
    y: 0
  }, "Show"), /*#__PURE__*/React.createElement("tspan", {
    className: "st62",
    x: 117.62,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 127.89,
    y: 0
  }, "&apos;Order"), /*#__PURE__*/React.createElement("tspan", {
    className: "st63",
    x: 179.4,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 189.66,
    y: 0
  }, "Not"), /*#__PURE__*/React.createElement("tspan", {
    className: "st62",
    x: 218.84,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 229.11,
    y: 0
  }, "Found&apos;"))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 1498.21,
    cy: 2596.64,
    r: 15.63
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 1488.55,
    y1: 2586.97,
    x2: 1507.88,
    y2: 2606.31
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 1507.88,
    y1: 2586.97,
    x2: 1488.55,
    y2: 2606.31
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1723.17,2358.7h106.15c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53h-106.15c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text55 || (_text55 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(1719.26 2392.46)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "-&gt;"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 17.2,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 38.92,
    y: 0
  }, "Continue"))), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1552.7 2734.57 1571.45 2753.33 1552.7 2772.08 1533.95 2753.33 1552.7 2734.57"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    x: 1196.6,
    y: 2806.46,
    width: 748.31,
    height: 389.26
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1540.18,2806.46v14.83l-15.63,15.63h-327.95"
  })), _text56 || (_text56 = /*#__PURE__*/React.createElement("text", {
    className: "st0",
    transform: "translate(1201.29 2829.17)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "View"), /*#__PURE__*/React.createElement("tspan", {
    className: "st22",
    x: 49.85,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 63.96,
    y: 0
  }, "Orders"), /*#__PURE__*/React.createElement("tspan", {
    className: "st22",
    x: 135.7,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 149.81,
    y: 0
  }, "(Custom"), /*#__PURE__*/React.createElement("tspan", {
    className: "st22",
    x: 238.53,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 252.64,
    y: 0
  }, "Action)"))), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1491.51 2939.23 1613.89 2939.23 1632.64 2957.98 1613.89 2976.74 1491.51 2976.74 1472.76 2957.98 1491.51 2939.23"
  })), _text57 || (_text57 = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(1491.51 2964.48)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "&quot;Orders"), /*#__PURE__*/React.createElement("tspan", {
    className: "st82",
    x: 58.64,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 71.38,
    y: 0
  }, "exist?&quot;"))), _text58 || (_text58 = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(1445.44 2954.36)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st85",
    x: 0,
    y: 0
  }, "ye"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.73,
    y: 0
  }, "s"))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1263.01,2992.36h245.86c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53h-245.86c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text59 || (_text59 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(1259.1 3026.12)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xABsuccess\xBB"), /*#__PURE__*/React.createElement("tspan", {
    className: "st66",
    x: 88.59,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 99.16,
    y: 0
  }, "Display"), /*#__PURE__*/React.createElement("tspan", {
    className: "st67",
    x: 160.64,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 171.21,
    y: 0
  }, "all"), /*#__PURE__*/React.createElement("tspan", {
    className: "st66",
    x: 189.97,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 200.54,
    y: 0
  }, "orders"))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1579.18,2992.36h280.57c10.78,0,19.53,8.75,19.53,19.53v14.27c0,10.78-8.75,19.53-19.53,19.53h-280.57c-10.78,0-19.53-8.75-19.53-19.53v-14.27c0-10.78,8.75-19.53,19.53-19.53Z"
  })), _text60 || (_text60 = /*#__PURE__*/React.createElement("text", {
    className: "st2",
    transform: "translate(1575.27 3026.12)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xABerror\xBB"), /*#__PURE__*/React.createElement("tspan", {
    className: "st78",
    x: 60.45,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 70.31,
    y: 0
  }, "Show"), /*#__PURE__*/React.createElement("tspan", {
    className: "st77",
    x: 117.22,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 127.07,
    y: 0
  }, "&apos;No"), /*#__PURE__*/React.createElement("tspan", {
    className: "st78",
    x: 154.63,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 164.49,
    y: 0
  }, "Orders"), /*#__PURE__*/React.createElement("tspan", {
    className: "st77",
    x: 221.79,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 231.65,
    y: 0
  }, "Found&apos;"))), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 1719.47,
    cy: 3092.58,
    r: 15.63
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 1709.8,
    y1: 3082.91,
    x2: 1729.13,
    y2: 3102.25
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 1729.13,
    y1: 3082.91,
    x2: 1709.8,
    y2: 3102.25
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1454.91 2863.48 1650.49 2863.48 1669.24 2882.23 1650.49 2900.98 1454.91 2900.98 1436.16 2882.23 1454.91 2863.48"
  })), _text61 || (_text61 = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(1558.95 2917.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st85",
    x: 0,
    y: 0
  }, "ye"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.73,
    y: 0
  }, "s"))), _text62 || (_text62 = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(1454.91 2888.72)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "&quot;View"), /*#__PURE__*/React.createElement("tspan", {
    className: "st75",
    x: 43.36,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 51.93,
    y: 0
  }, "Orders"), /*#__PURE__*/React.createElement("tspan", {
    className: "st76",
    x: 104.46,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 113.03,
    y: 0
  }, "Selected?&quot;"))), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1552.7 3139.46 1571.45 3158.21 1552.7 3176.97 1533.95 3158.21 1552.7 3139.46"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 1552.7,
    cy: 3242.6,
    r: 15.63
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 1543.03,
    y1: 3232.93,
    x2: 1562.37,
    y2: 3252.27
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 1562.37,
    y1: 3232.93,
    x2: 1543.03,
    y2: 3252.27
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1552.7,
    y1: 112.21,
    x2: 1552.7,
    y2: 143.46
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1546.45 127.84 1552.7 143.46 1558.95 127.84 1552.7 134.09 1546.45 127.84"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1552.7,
    y1: 196.8,
    x2: 1552.7,
    y2: 228.06
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1546.45 212.43 1552.7 228.06 1558.95 212.43 1552.7 218.68 1546.45 212.43"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 193.29,
    y1: 1011.4,
    x2: 193.29,
    y2: 1042.66
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "187.04 1027.03 193.29 1042.66 199.54 1027.03 193.29 1033.28 187.04 1027.03"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 193.29,
    y1: 1096,
    x2: 193.29,
    y2: 1127.25
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "187.04 1111.62 193.29 1127.25 199.54 1111.62 193.29 1117.87 187.04 1111.62"
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 523.3,
    y1: 1011.4,
    x2: 523.3,
    y2: 1042.66
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "517.05 1027.03 523.3 1042.66 529.55 1027.03 523.3 1033.28 517.05 1027.03"
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 271.42,
    y1: 923.69,
    x2: 193.29,
    y2: 923.69
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 193.29,
    y1: 923.69,
    x2: 193.29,
    y2: 958.06
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "187.04 942.44 193.29 958.06 199.54 942.44 193.29 948.69 187.04 942.44"
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 445.17,
    y1: 923.69,
    x2: 523.3,
    y2: 923.69
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 523.3,
    y1: 923.69,
    x2: 523.3,
    y2: 958.06
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "517.05 942.44 523.3 958.06 529.55 942.44 523.3 948.69 517.05 942.44"
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 193.29,
    y1: 1180.59,
    x2: 193.29,
    y2: 1214.97
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 193.29,
    y1: 1214.97,
    x2: 1533.95,
    y2: 1214.97
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1518.33 1208.72 1533.95 1214.97 1518.33 1221.22 1524.58 1214.97 1518.33 1208.72"
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 358.3,
    y1: 873.68,
    x2: 358.3,
    y2: 904.93
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "352.05 889.31 358.3 904.93 364.55 889.31 358.3 895.56 352.05 889.31"
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 844.78,
    y1: 873.68,
    x2: 844.78,
    y2: 904.93
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "838.53 889.31 844.78 904.93 851.03 889.31 844.78 895.56 838.53 889.31"
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 521.92,
    y1: 785.96,
    x2: 358.3,
    y2: 785.96
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 358.3,
    y1: 785.96,
    x2: 358.3,
    y2: 820.34
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "352.05 804.71 358.3 820.34 364.55 804.71 358.3 810.97 352.05 804.71"
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 681.16,
    y1: 785.96,
    x2: 844.78,
    y2: 785.96
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 844.78,
    y1: 785.96,
    x2: 844.78,
    y2: 820.34
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "838.53 804.71 844.78 820.34 851.03 804.71 844.78 810.97 838.53 804.71"
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 601.54,
    y1: 735.96,
    x2: 601.54,
    y2: 767.21
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "595.29 751.58 601.54 767.21 607.79 751.58 601.54 757.83 595.29 751.58"
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1190.46,
    y1: 735.96,
    x2: 1190.46,
    y2: 767.21
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1184.21 751.58 1190.46 767.21 1196.71 751.58 1190.46 757.83 1184.21 751.58"
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 787.73,
    y1: 648.24,
    x2: 601.54,
    y2: 648.24
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 601.54,
    y1: 648.24,
    x2: 601.54,
    y2: 682.62
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "595.29 666.99 601.54 682.62 607.79 666.99 601.54 673.24 595.29 666.99"
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1004.26,
    y1: 648.24,
    x2: 1190.46,
    y2: 648.24
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1190.46,
    y1: 648.24,
    x2: 1190.46,
    y2: 682.62
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1184.21 666.99 1190.46 682.62 1196.71 666.99 1190.46 673.24 1184.21 666.99"
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 896,
    y1: 598.23,
    x2: 896,
    y2: 629.49
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "889.75 613.86 896 629.49 902.25 613.86 896 620.11 889.75 613.86"
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1576.21,
    y1: 598.23,
    x2: 1576.21,
    y2: 629.49
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1569.96 613.86 1576.21 629.49 1582.46 613.86 1576.21 620.11 1569.96 613.86"
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1118.93,
    y1: 510.52,
    x2: 896,
    y2: 510.52
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 896,
    y1: 510.52,
    x2: 896,
    y2: 544.89
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "889.75 529.27 896 544.89 902.25 529.27 896 535.52 889.75 529.27"
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1353.29,
    y1: 510.52,
    x2: 1576.21,
    y2: 510.52
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1576.21,
    y1: 510.52,
    x2: 1576.21,
    y2: 544.89
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1569.96 529.27 1576.21 544.89 1582.46 529.27 1576.21 535.52 1569.96 529.27"
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1236.11,
    y1: 460.51,
    x2: 1236.11,
    y2: 491.76
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1229.86 476.14 1236.11 491.76 1242.36 476.14 1236.11 482.39 1229.86 476.14"
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1443.31,
    y1: 372.79,
    x2: 1236.11,
    y2: 372.79
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1236.11,
    y1: 372.79,
    x2: 1236.11,
    y2: 407.17
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1229.86 391.54 1236.11 407.17 1242.36 391.54 1236.11 397.8 1229.86 391.54"
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1662.09,
    y1: 372.79,
    x2: 1869.3,
    y2: 372.79
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1869.3,
    y1: 372.79,
    x2: 1869.3,
    y2: 407.17
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1863.05 391.54 1869.3 407.17 1875.55 391.54 1869.3 397.8 1863.05 391.54"
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1869.3,
    y1: 460.51,
    x2: 1869.3,
    y2: 1214.97
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1869.3,
    y1: 1214.97,
    x2: 1571.45,
    y2: 1214.97
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1587.08 1208.72 1571.45 1214.97 1587.08 1221.22 1580.83 1214.97 1587.08 1208.72"
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1552.7,
    y1: 281.39,
    x2: 1552.7,
    y2: 354.04
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1546.45 338.41 1552.7 354.04 1558.95 338.41 1552.7 344.66 1546.45 338.41"
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1163.68,
    y1: 1707.03,
    x2: 1163.68,
    y2: 1738.29
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1157.43 1722.66 1163.68 1738.29 1169.93 1722.66 1163.68 1728.91 1157.43 1722.66"
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 899.38,
    y1: 1619.32,
    x2: 843.3,
    y2: 1619.32
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 843.3,
    y1: 1619.32,
    x2: 843.3,
    y2: 1653.69
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "837.05 1638.07 843.3 1653.69 849.55 1638.07 843.3 1644.32 837.05 1638.07"
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1107.6,
    y1: 1619.32,
    x2: 1163.68,
    y2: 1619.32
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1163.68,
    y1: 1619.32,
    x2: 1163.68,
    y2: 1653.69
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1157.43 1638.07 1163.68 1653.69 1169.93 1638.07 1163.68 1644.32 1157.43 1638.07"
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 843.3,
    y1: 1707.03,
    x2: 843.3,
    y2: 1777.35
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 843.3,
    y1: 1777.35,
    x2: 1003.49,
    y2: 1777.35
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1003.49,
    y1: 1777.35,
    x2: 1003.49,
    y2: 1800.79
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "997.24 1785.17 1003.49 1800.79 1009.74 1785.17 1003.49 1791.42 997.24 1785.17"
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1003.49,
    y1: 1569.31,
    x2: 1003.49,
    y2: 1600.56
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "997.24 1584.94 1003.49 1600.56 1009.74 1584.94 1003.49 1591.19 997.24 1584.94"
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 829.8,
    y1: 1991.86,
    x2: 829.8,
    y2: 2023.11
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "823.55 2007.48 829.8 2023.11 836.05 2007.48 829.8 2013.73 823.55 2007.48"
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 829.8,
    y1: 2076.45,
    x2: 829.8,
    y2: 2107.7
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "823.55 2092.07 829.8 2107.7 836.05 2092.07 829.8 2098.33 823.55 2092.07"
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1177.18,
    y1: 1991.86,
    x2: 1177.18,
    y2: 2023.11
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1170.93 2007.48 1177.18 2023.11 1183.43 2007.48 1177.18 2013.73 1170.93 2007.48"
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 892.12,
    y1: 1904.14,
    x2: 829.8,
    y2: 1904.14
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 829.8,
    y1: 1904.14,
    x2: 829.8,
    y2: 1938.52
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "823.55 1922.89 829.8 1938.52 836.05 1922.89 829.8 1929.14 823.55 1922.89"
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1114.86,
    y1: 1904.14,
    x2: 1177.18,
    y2: 1904.14
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1177.18,
    y1: 1904.14,
    x2: 1177.18,
    y2: 1938.52
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1170.93 1922.89 1177.18 1938.52 1183.43 1922.89 1177.18 1929.14 1170.93 1922.89"
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 829.8,
    y1: 2161.04,
    x2: 829.8,
    y2: 2195.42
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 829.8,
    y1: 2195.42,
    x2: 1533.95,
    y2: 2195.42
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1518.33 2189.17 1533.95 2195.42 1518.33 2201.67 1524.58 2195.42 1518.33 2189.17"
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1003.49,
    y1: 1854.13,
    x2: 1003.49,
    y2: 1885.39
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "997.24 1869.76 1003.49 1885.39 1009.74 1869.76 1003.49 1876.01 997.24 1869.76"
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1550.42,
    y1: 1569.31,
    x2: 1550.42,
    y2: 1600.56
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1544.17 1584.94 1550.42 1600.56 1556.67 1584.94 1550.42 1591.19 1544.17 1584.94"
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1197.01,
    y1: 1481.59,
    x2: 1003.49,
    y2: 1481.59
  })), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1003.49,
    y1: 1481.59,
    x2: 1003.49,
    y2: 1515.97
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "997.24 1500.34 1003.49 1515.97 1009.74 1500.34 1003.49 1506.6 997.24 1500.34"
  })), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1356.89,
    y1: 1481.59,
    x2: 1550.42,
    y2: 1481.59
  })), _line79 || (_line79 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1550.42,
    y1: 1481.59,
    x2: 1550.42,
    y2: 1515.97
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1544.17 1500.34 1550.42 1515.97 1556.67 1500.34 1550.42 1506.6 1544.17 1500.34"
  })), _line80 || (_line80 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1276.95,
    y1: 1431.59,
    x2: 1276.95,
    y2: 1462.84
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1270.7 1447.21 1276.95 1462.84 1283.2 1447.21 1276.95 1453.46 1270.7 1447.21"
  })), _line81 || (_line81 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1430.54,
    y1: 1343.87,
    x2: 1276.95,
    y2: 1343.87
  })), _line82 || (_line82 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1276.95,
    y1: 1343.87,
    x2: 1276.95,
    y2: 1378.25
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1270.7 1362.62 1276.95 1378.25 1283.2 1362.62 1276.95 1368.87 1270.7 1362.62"
  })), _line83 || (_line83 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1674.87,
    y1: 1343.87,
    x2: 1828.45,
    y2: 1343.87
  })), _line84 || (_line84 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1828.45,
    y1: 1343.87,
    x2: 1828.45,
    y2: 1378.25
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1822.2 1362.62 1828.45 1378.25 1834.7 1362.62 1828.45 1368.87 1822.2 1362.62"
  })), _line85 || (_line85 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1828.45,
    y1: 1431.59,
    x2: 1828.45,
    y2: 2195.42
  })), _line86 || (_line86 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1828.45,
    y1: 2195.42,
    x2: 1571.45,
    y2: 2195.42
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1587.08 2189.17 1571.45 2195.42 1587.08 2201.67 1580.83 2195.42 1587.08 2189.17"
  })), _line87 || (_line87 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1552.7,
    y1: 1233.72,
    x2: 1552.7,
    y2: 1325.12
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1546.45 1309.49 1552.7 1325.12 1558.95 1309.49 1552.7 1315.74 1546.45 1309.49"
  })), _line88 || (_line88 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1160.11,
    y1: 2549.76,
    x2: 1160.11,
    y2: 2581.02
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1153.86 2565.39 1160.11 2581.02 1166.36 2565.39 1160.11 2571.64 1153.86 2565.39"
  })), _line89 || (_line89 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1160.11,
    y1: 2634.35,
    x2: 1160.11,
    y2: 2665.61
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1153.86 2649.98 1160.11 2665.61 1166.36 2649.98 1160.11 2656.23 1153.86 2649.98"
  })), _line90 || (_line90 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1498.21,
    y1: 2549.76,
    x2: 1498.21,
    y2: 2581.02
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1491.96 2565.39 1498.21 2581.02 1504.46 2565.39 1498.21 2571.64 1491.96 2565.39"
  })), _line91 || (_line91 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1249.22,
    y1: 2462.04,
    x2: 1160.11,
    y2: 2462.04
  })), _line92 || (_line92 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1160.11,
    y1: 2462.04,
    x2: 1160.11,
    y2: 2496.42
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1153.86 2480.8 1160.11 2496.42 1166.36 2480.8 1160.11 2487.05 1153.86 2480.8"
  })), _line93 || (_line93 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1409.1,
    y1: 2462.04,
    x2: 1498.21,
    y2: 2462.04
  })), _line94 || (_line94 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1498.21,
    y1: 2462.04,
    x2: 1498.21,
    y2: 2496.42
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1491.96 2480.8 1498.21 2496.42 1504.46 2480.8 1498.21 2487.05 1491.96 2480.8"
  })), _line95 || (_line95 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1160.11,
    y1: 2718.95,
    x2: 1160.11,
    y2: 2753.33
  })), _line96 || (_line96 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1160.11,
    y1: 2753.33,
    x2: 1533.95,
    y2: 2753.33
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1518.33 2747.08 1533.95 2753.33 1518.33 2759.58 1524.58 2753.33 1518.33 2747.08"
  })), _line97 || (_line97 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1329.16,
    y1: 2412.04,
    x2: 1329.16,
    y2: 2443.29
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1322.91 2427.67 1329.16 2443.29 1335.41 2427.67 1329.16 2433.92 1322.91 2427.67"
  })), _line98 || (_line98 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1433.56,
    y1: 2324.32,
    x2: 1329.16,
    y2: 2324.32
  })), _line99 || (_line99 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1329.16,
    y1: 2324.32,
    x2: 1329.16,
    y2: 2358.7
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1322.91 2343.07 1329.16 2358.7 1335.41 2343.07 1329.16 2349.32 1322.91 2343.07"
  })), _line100 || (_line100 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1671.84,
    y1: 2324.32,
    x2: 1776.24,
    y2: 2324.32
  })), _line101 || (_line101 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1776.24,
    y1: 2324.32,
    x2: 1776.24,
    y2: 2358.7
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1769.99 2343.07 1776.24 2358.7 1782.49 2343.07 1776.24 2349.32 1769.99 2343.07"
  })), _line102 || (_line102 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1776.24,
    y1: 2412.04,
    x2: 1776.24,
    y2: 2753.33
  })), _line103 || (_line103 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1776.24,
    y1: 2753.33,
    x2: 1571.45,
    y2: 2753.33
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1587.08 2747.08 1571.45 2753.33 1587.08 2759.58 1580.83 2753.33 1587.08 2747.08"
  })), _line104 || (_line104 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1552.7,
    y1: 2214.17,
    x2: 1552.7,
    y2: 2305.57
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1546.45 2289.94 1552.7 2305.57 1558.95 2289.94 1552.7 2296.19 1546.45 2289.94"
  })), _line105 || (_line105 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1719.47,
    y1: 3045.7,
    x2: 1719.47,
    y2: 3076.95
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1713.22 3061.33 1719.47 3076.95 1725.72 3061.33 1719.47 3067.58 1713.22 3061.33"
  })), _line106 || (_line106 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1472.76,
    y1: 2957.98,
    x2: 1385.94,
    y2: 2957.98
  })), _line107 || (_line107 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1385.94,
    y1: 2957.98,
    x2: 1385.94,
    y2: 2992.36
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1379.69 2976.74 1385.94 2992.36 1392.19 2976.74 1385.94 2982.99 1379.69 2976.74"
  })), _line108 || (_line108 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1632.64,
    y1: 2957.98,
    x2: 1719.47,
    y2: 2957.98
  })), _line109 || (_line109 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1719.47,
    y1: 2957.98,
    x2: 1719.47,
    y2: 2992.36
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1713.22 2976.74 1719.47 2992.36 1725.72 2976.74 1719.47 2982.99 1713.22 2976.74"
  })), _line110 || (_line110 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1385.94,
    y1: 3045.7,
    x2: 1385.94,
    y2: 3116.02
  })), _line111 || (_line111 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1385.94,
    y1: 3116.02,
    x2: 1552.7,
    y2: 3116.02
  })), _line112 || (_line112 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1552.7,
    y1: 3116.02,
    x2: 1552.7,
    y2: 3139.46
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1546.45 3123.83 1552.7 3139.46 1558.95 3123.83 1552.7 3130.09 1546.45 3123.83"
  })), _line113 || (_line113 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1552.7,
    y1: 2900.98,
    x2: 1552.7,
    y2: 2939.23
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1546.45 2923.6 1552.7 2939.23 1558.95 2923.6 1552.7 2929.85 1546.45 2923.6"
  })), _line114 || (_line114 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1669.24,
    y1: 2882.23,
    x2: 1910.53,
    y2: 2882.23
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1904.28 3024.5 1910.53 3040.13 1916.78 3024.5 1910.53 3030.75 1904.28 3024.5"
  })), _line115 || (_line115 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1910.53,
    y1: 2882.23,
    x2: 1910.53,
    y2: 3158.21
  })), _line116 || (_line116 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1910.53,
    y1: 3158.21,
    x2: 1571.45,
    y2: 3158.21
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1587.08 3151.96 1571.45 3158.21 1587.08 3164.46 1580.83 3158.21 1587.08 3151.96"
  })), _line117 || (_line117 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1552.7,
    y1: 2772.08,
    x2: 1552.7,
    y2: 2863.48
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1546.45 2847.85 1552.7 2863.48 1558.95 2847.85 1552.7 2854.1 1546.45 2847.85"
  })), _line118 || (_line118 = /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1552.7,
    y1: 3176.97,
    x2: 1552.7,
    y2: 3226.97
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1546.45 3211.34 1552.7 3226.97 1558.95 3211.34 1552.7 3217.6 1546.45 3211.34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowChartFinal);
export default __webpack_public_path__ + "static/media/FlowChartFinal.ac098fa98a1c8f9c92313deeafb25135.svg";
export { ForwardRef as ReactComponent };